import styles from './style.module.scss';
import createContainer from '../ContainerFactory';

export default createContainer(styles.buttonContainer);
